function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import ResultPanel, { replacement } from './ResultPanel';
import ButtonPanel from './ButtonPanel';
import { evaluate } from 'mathjs';

var Calculator = function (_React$Component) {
  _inherits(Calculator, _React$Component);

  function Calculator() {
    _classCallCheck(this, Calculator);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.state = {
      last: '',
      cur: '0'
    };
    _this.onPaste = _this.onPaste.bind(_this);
    _this.onButtonClick = _this.onButtonClick.bind(_this);
    _this.setStateAndNotify = _this.setStateAndNotify.bind(_this);
    _this.keyMap = {};
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  Calculator.prototype.onPaste = function onPaste(event) {
    if (event.isTrusted) {
      var data = event.clipboardData || window.clipboardData;
      var pastedData = data.getData('Text');
      var cur = void 0;
      replacement.forEach(function (item) {
        cur = pastedData.replace(item.dist, item.reg);
      });

      try {
        this.setStateAndNotify({
          cur: evaluate(cur).toString(),
          last: cur
        });
      } catch (e) {
        this.setStateAndNotify({
          cur: cur,
          last: 'Not a valid expression'
        });
      }
    }
  };

  Calculator.prototype.setStateAndNotify = function setStateAndNotify(newState) {
    this.setState(newState, this.props.onResultChange ? this.props.onResultChange({
      expression: newState.last,
      result: newState.cur
    }) : null);
  };

  Calculator.prototype.handleKeyDown = function handleKeyDown(event) {
    var button = void 0;

    if (event.ctrlKey || event.keyCode === 67) {
      return;
    }

    var key = (event.shiftKey ? 'shift+' : '') + event.keyCode || event.which;

    if (button = this.keyMap[key]) {
      button.click();
      event.stopPropagation();
      event.preventDefault();
    }
  };

  Calculator.prototype.onButtonClick = function onButtonClick(type) {
    var cur = this.state.cur;
    var lastLetter = cur.slice(-1);

    switch (type) {
      case 'c':
        this.setStateAndNotify({
          last: '',
          cur: '0'
        });
        break;

      case 'back':
        this.setState({
          cur: cur === '0' ? cur : cur.slice(0, -1) || '0'
        });
        break;

      case '=':
        try {
          var output = evaluate(cur).toString();
          this.setStateAndNotify({
            last: cur + '=',
            cur: output
          });
        } catch (e) {
          console.log(e);
          this.setState({
            last: cur + '=',
            cur: 'NaN'
          });
        }

        break;

      case '+':
      case '-':
      case '*':
      case '/':
        if (Number(cur) === 0 && type === '-') {
          this.setState({
            cur: type
          });
          break;
        }

        if (lastLetter === '*' && type === '-' || lastLetter === '/' && type === '-') {
          this.setState({
            cur: cur + type
          });
          break;
        }

        if (lastLetter === '+' || lastLetter === '-' || lastLetter === '*' || lastLetter === '/') this.setState({
          cur: cur.slice(0, -1) + type
        });else this.setState({
          cur: cur + type
        });
        break;

      case '.':
        if (lastLetter !== '.') {
          this.setState({
            cur: cur + type
          });
        }

        break;

      default:
        this.setState({
          cur: cur === '0' ? type : cur + type
        });
        break;
    }

    if (this.props.onNewInput) {
      this.props.onNewInput({
        expression: this.state.cur,
        key: type
      });
    }
  };

  Calculator.prototype.render = function render() {
    var _this2 = this;

    return React.createElement('div', {
      className: 'react-calculator',
      onPaste: this.onPaste,
      onKeyDown: this.handleKeyDown
    }, React.createElement(ResultPanel, this.state), React.createElement(ButtonPanel, {
      onClick: this.onButtonClick,
      onLoad: function onLoad(keyMap) {
        _this2.keyMap = keyMap;
      }
    }));
  };

  return Calculator;
}(React.Component);

export { Calculator as default };
Calculator.propTypes = process.env.NODE_ENV !== "production" ? {
  onNewInput: PropTypes.func,
  onResultChange: PropTypes.func
} : {};